// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const accessPolicySchema = z.object({
  "application_id": z.string().uuid(),
  "is_requestable": z.boolean(),
  "default_duration_minutes": z.number().int().min(15).max(43200),
  "max_duration_minutes": z.number().int().min(15).max(43200),
  "auto_approve_self": z.boolean()
});
